import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import logoBA from "../assets/icons/logo-Bonhomme-Automobile.svg";
import { ReactComponent as UserIcon } from "../assets/icons/profile-user-account.svg";
import {
  connexionEmpreinteDisponible,
  seConnecterAvecEmpreinte,
} from "../services/webauthn";

/* Icône « fingerprint » de Lucide, en SVG inline : ce front n'embarque pas
   lucide-react, et le fichier pose déjà ses icônes de cette façon. */
const FingerprintIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4" />
    <path d="M5 19.5C5.5 18 6 15 6 12c0-.7.12-1.37.34-2" />
    <path d="M17.29 21.02c.12-.6.43-2.3.5-3.02" />
    <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4" />
    <path d="M8.65 22c.21-.66.45-1.32.57-2" />
    <path d="M14 13.12c0 2.38 0 6.38-1 8.88" />
    <path d="M2 16h.01" />
    <path d="M21.8 16c.2-2 .131-5.354 0-6" />
    <path d="M9 6.8a6 6 0 0 1 9 5.2c0 .47 0 1.17-.02 2" />
  </svg>
);

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorVisible, setErrorVisible] = useState(false);
  const [erreurEmpreinte, setErreurEmpreinte] = useState("");
  // Le bouton n'apparaît que si l'appareil a un capteur *et* le serveur est
  // configuré : proposer une connexion qui ne peut qu'échouer est pire que rien.
  const [empreinteDisponible, setEmpreinteDisponible] = useState(false);
  const [empreinteEnCours, setEmpreinteEnCours] = useState(false);
  // Repli sur le chemin relatif : nginx sert l'API auth sous /api/auth. Sans lui,
  // une variable d'environnement absente au build donnait une URL « undefined/... ».
  const API = process.env.REACT_APP_API_AUTH || "/api/auth";

  const redirection = Cookies.get("from_location");

  useEffect(() => {
    let annule = false;
    connexionEmpreinteDisponible().then((dispo) => {
      if (!annule) setEmpreinteDisponible(dispo);
    });
    return () => {
      annule = true;
    };
  }, []);

  // Même destination que le login par mot de passe : la session obtenue est la même.
  const allerAuPortail = () => {
    const target = redirection || "/portail";
    window.location.href = `${window.location.origin}${target}`;
  };

  const handleEmpreinte = async () => {
    setErreurEmpreinte("");
    setEmpreinteEnCours(true);
    try {
      const resultat = await seConnecterAvecEmpreinte();
      if (resultat.ok) {
        allerAuPortail();
        return;
      }
      // Annulation ou délai dépassé : l'utilisateur reprend la main sur le
      // formulaire, ce n'est pas une erreur à afficher en rouge.
      if (!resultat.annule) {
        setErreurEmpreinte(resultat.message || "Connexion par empreinte impossible.");
      }
    } finally {
      setEmpreinteEnCours(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log({ email, password, rememberMe });
    const dataLogin = {
      username: email,
      password: password,
      remember: rememberMe,
    };
    console.log("dataLogin : ", dataLogin);
    if (email == "" || password == "") {
      alert("Veuillez renseigner l'identifiant et le mot de passe");
    } else {
      axios
        .post(`${API}/api/login`, dataLogin, {
          withCredentials: true, /////////////////////   IMPORTANT POUR STOCKER LES COOKIES DANS LE NAVIGATEUR
        })
        .then((response) => {
          console.log("REPONSE : ", response);
          console.log("Test : ", redirection);
          allerAuPortail();
        })
        .catch((error) => {
          console.error("Erreur login : ", error);
          setErrorVisible(true);
          setTimeout(() => {
            setErrorVisible(false);
          }, 3000);
        });
      // Ajoutez ici la logique pour gérer la soumission du formulaire
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleForgotPassword = () => {
    console.log("Mot de passe oublié !");
  };

  return (
    <div className="container">
      <form className="form" onSubmit={handleSubmit}>
        <h1>
          <img src={logoBA} alt="Logo Bonhomme Automobile" />
        </h1>
        <div className="inputForm">
          <UserIcon height="25" width="20" />
          <input
            type="text"
            className="input"
            placeholder="Identifiant"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="inputForm">
          <svg
            height="20"
            viewBox="-64 0 512 512"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m336 512h-288c-26.453125 0-48-21.523438-48-48v-224c0-26.476562 21.546875-48 48-48h288c26.453125 0 48 21.523438 48 48v224c0 26.476562-21.546875 48-48 48zm-288-288c-8.8125 0-16 7.167969-16 16v224c0 8.832031 7.1875 16 16 16h288c8.8125 0 16-7.167969 16-16v-224c0-8.832031-7.1875-16-16-16zm0 0"></path>
            <path d="m304 224c-8.832031 0-16-7.167969-16-16v-80c0-52.929688-43.070312-96-96-96s-96 43.070312-96 96v80c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-80c0-70.59375 57.40625-128 128-128s128 57.40625 128 128v80c0 8.832031-7.167969 16-16 16zm0 0"></path>
          </svg>
          <input
            type={showPassword ? "text" : "password"}
            className="input"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <svg
            className="showPointer"
            onClick={togglePasswordVisibility}
            viewBox="0 0 576 512"
            height="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
          </svg>
        </div>

        <div className="flex-row">
          <div className="showPointer">
            <input
              type="checkbox"
              id="rememberMeCheckbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label htmlFor="rememberMeCheckbox">Rester connecté</label>
          </div>
          <span className="span" onClick={handleForgotPassword}>
            Mot de passe oublié ?
          </span>
        </div>
        <button type="submit" className="button-submit">
          Connexion
        </button>

        {/* Connexion par empreinte. Sous le mot de passe et non au-dessus : c'est
            une alternative, et le formulaire doit rester la voie évidente pour qui
            n'a rien enregistré. */}
        {empreinteDisponible && (
          <>
            <div className="separateur">
              <span>ou</span>
            </div>
            <button
              type="button"
              className="btn"
              onClick={handleEmpreinte}
              disabled={empreinteEnCours}
              title="Se connecter avec l'empreinte digitale enregistrée sur cet appareil"
            >
              <FingerprintIcon />
              {empreinteEnCours ? "Vérification…" : "Connexion par empreinte"}
            </button>
            <p className="p-aide">
              Il faut d'abord activer l'empreinte depuis le portail, une fois connecté.
            </p>
          </>
        )}

        {errorVisible && (
          <div className="error-popup">Login ou mot de passe incorrect</div>
        )}
        {erreurEmpreinte && <div className="error-popup">{erreurEmpreinte}</div>}
      </form>
    </div>
  );
};

export default LoginForm;
